module.exports = __webpack_public_path__ + "static/00-hero-new@2x-f6a65160e5b1177c269e9e1b7e0cf7d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/00-hero-new@2x.jpg
// module id = 2636
// module chunks = 35783957827783